import defaultPosition from "@/helpers/wc/positionSettings";

export const visitExpressSearchSettings = {
  title: "VisitExpress Search",
  name: "visitExpressSearchBase",

  styles: defaultPosition,

  properties: {
    text: [],
    confirmationDialog: [],
    personConfirm: [],
    includeCompanyName: false,
    includeLicensePlate: false,
    routeName: '',
    smsVisitor: false,
    css: {
      button: {
        fontFamily: "Arial",
        fontSize: 14,
        color: 'white',
        backgroundColor: 'limegreen',
        borderColor: 'grey',
        borderRadius: '5px'
      }
    }
  },
  cssLegend: {
    button: {
      name: 'wcButton',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      borderColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    }
  }
};
